import { defineFcm } from '../shared/factory';

export const FCM_ENABLE_PETITION_STRENGTH_TIPS = defineFcm('enable_petition_strength_tips')
	.asBoolean()
	.withDefault(false)
	.toConfig({
		owner: 'squad-starfish',
		scope: 'corgi-front-end',
		context: 'Petition Show Page',
		description: 'Used to enable the Carousel showing tips to enhance the strength of the petition',
		import: false,
	});
